import {
  Flex,
  Input,
  InputGroup,
  InputLeftElement,
  Stack,
  Box,
  Text,
  VStack,
  HStack,
  Select,
  useColorMode,
  useColorModeValue,
  Icon,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuDivider,
  IconButton,
  Button,
  Avatar,
  WrapItem,
  CloseButton
} from '@chakra-ui/react';
import {FiSearch, FiChevronDown} from 'react-icons/fi';

export const AppToolbar = ({onClose}: any) => {
  return (
    <Flex
      p='16px 24px'
      justifyContent='space-between'
      alignItems='center'
      backgroundColor={useColorModeValue('white', 'gray.900')}
      backdropFilter='auto'
      backdropBlur='6px'
      zIndex={2}
      position='relative'
      boxShadow={useColorModeValue(
        '1px 0px 15px #E8E8E8',
        '1px 0px 15px #131212'
      )}
      borderBottom='1px'
      borderBottomColor={useColorModeValue('gray.200', 'gray.700')}
    >
      <CloseButton
        aria-label='schließen'
        display={{base: 'flex', md: 'none'}}
        onClick={onClose}
      />
      <HStack gap={4}>
        <Box as={'form'}>
          <HStack spacing={4}>
            <InputGroup>
              <InputLeftElement
                pointerEvents='none'
                children={<Icon fontSize='20' as={FiSearch} />}
              />
              <Input
                variant='filled'
                type='tel'
                placeholder='Alles durchsuchen...'
              />
            </InputGroup>
          </HStack>
        </Box>
      </HStack>
    </Flex>
  );
};
